const T_PREFIX = "top-popular-clone-card";

export const propertiesTrns = {
  industry: `${T_PREFIX}.properties.industry`,
  investment: `${T_PREFIX}.properties.investment`,
  investmentValue: `${T_PREFIX}.properties.investment.value`,
}
